import InterviewMeetingDetails from './InterviewMeetingDetails';
export default InterviewMeetingDetails;